import { useToastedMutation } from '../../../../ReactQuery';
import { post } from '../../../../redux/api';
import { nuc } from '../../../../utils';
import type { ManuallyAddedDependencyRequest } from '../../../../../typings/api';

const addDependency = async (parentLocator: string, params: ManuallyAddedDependencyRequest) => {
  await post(`/api/revisions/${nuc(parentLocator)}/dependencies`, { dependencyData: params });

  // Return the params here so that they can be used in the toast messages.
  return params;
};

/**
 * Hook for adding (or replacing) a dependency within a user revision.
 */
export default function useAddDependency(parentLocator: string) {
  return useToastedMutation({
    mutationFn: async (params: ManuallyAddedDependencyRequest) => addDependency(parentLocator, params),
    successToastMessage: (params: ManuallyAddedDependencyRequest) => params.kind === 'replace'
      ? 'Dependency replaced successfully.'
      : 'Dependency added successfully.',
    errorToastMessage: (params: ManuallyAddedDependencyRequest) => params.kind === 'replace'
      ? 'Failed to replace dependency.'
      : 'Failed to add dependency.',
  });
}
